import React from 'react';
import { Button, Tooltip, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { GroupSettingsFooterProps } from '@modules/digital-signage/model/group-settings.model.ts';

const GroupSettingsFooter: React.FC<GroupSettingsFooterProps> = ({
  hasChanges,
  isLoading,
  isCreatingFromDefault
}) => {
  const { t } = useTranslation();

  return (
    <div className="absolute bottom-6 right-6 flex items-center gap-4">
      {hasChanges && (
        <div className="flex items-center gap-1.5">
          <span className="w-2 h-2 rounded-full bg-(--yellow)" />
          <Typography variant="caption" className="text-(--yellow)!">
            {t('digital_signage_group_unsaved_changes')}
          </Typography>
        </div>
      )}
      <Tooltip
        title={hasChanges ? '' : t('digital_signage_group_no_changes')}
        placement="top"
      >
        <span>
          <Button
            type="submit"
            variant="contained"
            disabled={!hasChanges}
            loading={isLoading}
          >
            {t(
              isCreatingFromDefault
                ? 'digital_signage_group_create_button'
                : 'save'
            )}
          </Button>
        </span>
      </Tooltip>
    </div>
  );
};

export default GroupSettingsFooter;
